var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3210_7843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 0H0V512H512V0Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 0H0V512H512V0Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M317.474 256L348.208 202.766H286.739L256 149.523L225.261 202.766H163.792L194.526 256L163.792 309.234H225.261L256 362.477L286.739 309.234H348.208L317.474 256ZM318.054 220.176L307.422 238.591L296.79 220.176H318.054ZM297.371 256L276.688 291.824H235.312L214.629 256L235.312 220.176H276.688L297.371 256ZM256 184.344L266.636 202.766H245.364L256 184.344ZM193.946 220.176H215.21L204.578 238.591L193.946 220.176ZM193.946 291.824L204.578 273.409L215.21 291.824H193.946ZM256 327.656L245.364 309.234H266.636L256 327.656ZM307.423 273.409L318.055 291.824H296.791L307.423 273.409Z",
    fill: "#41479B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3210_7843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIl);
export default __webpack_public_path__ + "static/media/IL.5e7aef6ff822bfe84d367b99b004485e.svg";
export { ForwardRef as ReactComponent };